import $ from 'jquery';
import _ from 'ext:lodash';
import nearestClubService from 'framework/services/nearestClubService';
import assetsService from 'framework/services/assetsService';

let prospectClubBannerEl = $('#prspGeoClubBanner');
let prospectCurrentEl = prospectClubBannerEl.find('#prspGeoClubCurrent');
let prospectCurrentBtn = prospectClubBannerEl.find('#prspGeoClubCurrentBtn');
let prospectCurrentImg = prospectClubBannerEl.find('#prspGeoClubImg');
let prospectNearbyEl = prospectClubBannerEl.find('#prspGeoClubOther');
let prospectImageLg = prospectClubBannerEl.find('source[media="(min-width: 992px)"]');
let prospectImageSm = prospectClubBannerEl.find('source[media="(min-width: 544px)"]');
let prospectImageXs = prospectClubBannerEl.find('img:not(#prspGeoClubSideBySide)');
let prospectImageSBS = prospectClubBannerEl.find('#prspGeoClubSideBySide');

const lgAppend = '-lg.jpg';
const smAppend = '-sm.jpg';
const xsAppend = '-xs.jpg';

function updateImagePaths(path) {
	let cutPath;
	if(path) {
		// update the file name without the breakpoint and file extension appended
		cutPath = path.substring(0, path.lastIndexOf('-'));
		// update element paths
		if(prospectImageLg.length > 0) {
			prospectImageLg.attr('srcset', cutPath + lgAppend);
		}
		if(prospectImageSBS.length > 0) {
			prospectImageSBS.attr('src', cutPath + smAppend);
		}
		prospectImageSm.attr('srcset', cutPath + smAppend);
		prospectImageXs.attr('src', cutPath + xsAppend);
	}
	// make picture element visible
	prospectCurrentImg.css('visibility', 'visible');
}

function getAssets(club) {
	let tagString = '';

	if(club) {
		tagString += 'properties:geo,club:' + club.state.toLowerCase() + '/' + club.id;
	}

	assetsService.api.getAssetsByTag(tagString)
		.then(
			(response) => {
				if(response.length) {
					updateImagePaths(response[0].path);
				} else{
					updateImagePaths(null);
				}
			},
			(error) => {
				updateImagePaths(null);
			}
		);
}

function makeNearClubLink(club) {
	const comingSoon = club.comingSoon ? ' - ' + club.comingSoon : '';
	return `<a href="${club.prospectPagePath}">${club.name}</a> ${comingSoon}`;
}

function updateClubInfo(club) {
	const comingSoon = club.description ? '<span class="d-block h4">' + club.description + '</span>' : '';
	prospectCurrentEl.html(club.name + comingSoon);
	prospectCurrentBtn.attr('href', club.prospectPagePath);

	const nearestClubQuery = {
		distance: 50,
		limit: 4,
		cId: club.id
	};

	let nearestContent = '<p>No other clubs found within 50 miles.</p>';

	nearestClubService.getNearestClubs(nearestClubQuery).then((data)=> {
		if(data && data.length) {
			data.shift(); // remove first element (this club) so we're left with max 3 nearby clubs
			const nearestClubs = data;

			if(nearestClubs.length > 0) {
				nearestContent = '<ul class="list-bulleted">';
				$.each(nearestClubs, function( index, nearby ) {
					nearestContent += '<li>' + makeNearClubLink(nearby) + '</li>';
				});
				nearestContent += '</ul>';
			}
		}
	})
	.finally(() => {
		prospectNearbyEl.html(nearestContent);
	});
}

if(prospectClubBannerEl.length) {
	window.ef.prospectProfileStore.listen((profile) => {
		updateClubInfo(profile.club);
		getAssets(profile.club);
	});
}
